import { render, staticRenderFns } from "./ServiceRate.vue?vue&type=template&id=3857a22f&scoped=true&"
import script from "./ServiceRate.vue?vue&type=script&setup=true&lang=js&"
export * from "./ServiceRate.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ServiceRate.vue?vue&type=style&index=0&id=3857a22f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3857a22f",
  null
  
)

export default component.exports